<!-- Conditional Labels Component -->
<div class="conditional-labels-container">
  <!-- Action Type Selection -->
  <div class="action-type-container">
    <div class="btn-group" role="group">
      <button type="button" class="btn" [class.active]="selectedActionType === 'display'"
        [disabled]="readOnly" (click)="onActionTypeChange('display')">
        Display
      </button>
      <button type="button" class="btn" [class.active]="selectedActionType === 'custom'"
        [disabled]="readOnly" (click)="onActionTypeChange('custom')">
        Custom
      </button>
    </div>
  </div>


  <div class="row" style="background: #f8f9fa; padding: 12px; border-radius: 5px;">
    <div class="col col-md-3">Options Names</div>
    <div class="col col-md-4">Condition Label</div>
    <div class="col col-md-5">Conditions</div>
  </div>
  <div class="row" style="padding: 12px;" *ngFor="let option of interaction.sub_questions">
    <div class="col col-md-3"><strong>{{option.text}}</strong></div>
    <div class="col col-md-9 label-condition--container">
      <ng-container *ngIf="option?.conditionalLabel && option.conditionalLabel[option.labelId]">
        <div class="row label-condition-row"
          *ngFor="let cLabel of option.conditionalLabel[option.labelId];let cLabelIndex = index;">
          <!-- cLabel {{cLabel|json}} -->
          <div class="col col-md-5 label-container">
            <div class="label-input">
              <textarea class="form-control" [disabled]="readOnly" [(ngModel)]="cLabel.text" placeholder="New Label">
            </textarea>
            </div>

            <!-- Remove Label Button -->
            <button type="button" class="btn-icon delete-label-btn" [disabled]="readOnly" (click)="removeConditionalLabel(cLabel, option)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
          <div class="col col-md-7 condition-container">
            <div class="conditions-section">
              <!-- Display Conditions -->
              <div *ngIf="selectedActionType === 'display' && logicDetailsMap[cLabel.field_id] && logicDetailsMap[cLabel.field_id].logicDetail && logicDetailsMap[cLabel.field_id].logicDetail[1] && logicDetailsMap[cLabel.field_id].logicDetail[1].transformString">
                <!-- <div class="condition-item"
                  *ngFor="let logic of getLogicDetails(option.field_id, cLabel.field_id);let isFirst = first;let isLast = last"> -->
                <div class="condition-item"
                  *ngFor="let logic of  logicDetailsMap[cLabel.field_id].logicDetail[1].transformString;index as i;first as isFirst ;last as isLast">
                  <!-- Logical Operator -->
                  <!-- logic {{logic|json}} -->
                  <div class="logical-operator" *ngIf="!isFirst && isDisplayCondtionActive">
                    <div class="btn-group">
                      <button type="button" class="btn" *ngFor="let op of logicalOperators"
                        [class.btn-primary]="logic.logicalOptr === op.value"
                        [class.active]="logic.logicalOptr !== op.value"
                        [disabled]="readOnly" (click)="updateLogicalOperator(logic, op.value)">
                        {{op.text}}
                      </button>
                    </div>
                  </div>

                  <!-- Condition Expression -->
                  <div class="condition-expression" *ngIf="logic.isValid">
                    <div class="expression-content">
                      <span *ngIf="logic.target === 'target_value'">
                        {{getQuestionText(logic.interaction)}}
                        <strong>{{getOperatorText(logic.comparisonOptr)}}</strong>
                        {{logic.value}}
                      </span>
                      <span *ngIf="logic.target === 'target_field'">
                        {{getQuestionText(logic.interaction)}}
                        <strong>{{getOperatorText(logic.comparisonOptr)}}</strong>
                        {{getQuestionText(logic.targetInteraction)}}
                      </span>
                    </div>
                    <div class="expression-actions">
                      <button class="btn-icon" [disabled]="readOnly" (click)="editCondition(logic)">
                        <i class="fa fa-edit"></i>
                      </button>
                      <button class="btn-icon" [disabled]="readOnly" (click)="removeCondition(logic)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Condition Editor -->
                  <div class="condition-editor" *ngIf="logic.isOpen && cLabel.text && cLabel.text != ''">
                    <form #conditionForm="ngForm"
                      (ngSubmit)="addCondition(logic, option.field_id, cLabel.field_id,  cLabelIndex)">
                      <div class="form-group">
                        <!-- Question Selection -->
                        <select class="form-control" [disabled]="readOnly" [(ngModel)]="logic.interaction" name="interaction"
                          (ngModelChange)="onQuestionChange(cLabel.field_id,logic)" required>
                          <option value="" disabled>Select Question</option>
                          <ng-container *ngFor="let question of questionMapForOptions[option.field_id];">
                            <option [value]="question?.field_id" *ngIf="isQuestion(question) && question?.field_id">
                              {{question?.text}}
                            </option>
                            <optgroup [label]="question?.text" *ngIf="isQuestionGroup(question) && question?.field_id">
                              <option [value]="opt.field_id" *ngFor="let opt of question?.options">
                                {{opt.text}}</option>
                            </optgroup>
                          </ng-container>

                        </select>
                      </div>
                      <div class="form-group">
                        <!-- Comparison Operator -->
                        <select class="form-control" [disabled]="readOnly || !logic.interaction" [(ngModel)]="logic.comparisonOptr" name="comparisonOptr"
                          required>
                          <option value="" disabled>Select Operator</option>
                          <option *ngFor="let op of comparisonOperators" [value]="op.value">
                            {{op.text}}
                          </option>
                        </select>

                        <!-- Target Type -->
                        <select class="form-control" [disabled]="readOnly || !logic.comparisonOptr" [(ngModel)]="logic.target" name="target"
                          required>
                          <option value="" disabled>Select Target</option>
                          <option value="target_value">Value</option>
                          <option value="target_field">Question</option>
                        </select>

                        <!-- Target Value/Field -->
                        <div *ngIf="logic.target === 'target_value'">
                          <select class="form-control" [disabled]="readOnly" [(ngModel)]="logic.value" name="value"
                            (ngModelChange)="onValueChange(logic)" required>
                            <option value="" disabled>Select Value</option>
                            <ng-container *ngIf="logic?.configuration && logic?.configuration?.length">
                              <option *ngFor="let config of logic.configuration" [value]="config.value">
                                {{config.label}} ({{config.value}})
                              </option>
                            </ng-container>

                          </select>
                        </div>

                        <div *ngIf="logic.target === 'target_field'">
                          <select class="form-control" [disabled]="readOnly" [(ngModel)]="logic.targetInteraction" name="targetInteraction"
                            required>
                            <option value="" disabled>Select Question</option>
                            <ng-container *ngFor="let question of questionMapForOptions[option.field_id]">
                              <option [value]="question?.field_id" *ngIf="isQuestion(question) && question?.field_id">
                                {{question?.text}}
                              </option>
                              <optgroup [label]="question?.text"
                                *ngIf="isQuestionGroup(question) && question?.field_id">
                                <option [value]="opt.field_id" *ngFor="let opt of question?.options">
                                  {{opt.text}}
                                </option>
                              </optgroup>
                            </ng-container>
                          </select>



                        </div>
                      </div>

                      <!-- Action Buttons -->
                      <div class="form-actions">
                        <button type="submit" class="btn btn-success" [disabled]="readOnly || !conditionForm.valid">
                          <i class="fa fa-check"></i>
                        </button>
                        <button type="button" class="btn btn-danger" [disabled]="readOnly" (click)="closeCondition(cLabel.field_id,logic)">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                <!-- Add Condition Button -->
                <div class="condition-btn-group">
                  <button type="button" class="btn btn-primary add-condition" [disabled]="readOnly || !cLabel.text"
                    (click)="toggleAddCondition(cLabel, option.field_id)">
                    Add Condition
                  </button>
                </div>
              </div>

              <!-- Custom Expression -->
              <div *ngIf="selectedActionType === 'custom'">
                <div class="custom-expression">
                  <label>Provide Custom Expression</label>
                  <textarea class="form-control" [disabled]="readOnly"
                    [(ngModel)]="logicDetailsMap[cLabel.field_id].logicDetail[logicAction].logicString"
                    (blur)="updateCustomExpression(option.field_id, cLabel.field_id, cLabelIndex, '3')"
                    placeholder="Provide custom expression">
                </textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="row">
        <div class="col col-md-12">
          <button type="button" class="btn btn-primary add-label" [disabled]="readOnly" (click)="addNewConditionalLabel(option)">
            Add Label
          </button>
        </div>
      </div>
    </div>

  </div>
</div>